// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail--JiiWugxP{margin-top:20px;color:#595959;margin-bottom:7px}.code-block--wccWPbbW::part(pre){border:1px solid #ccd1de}.code-fallback--a8nCduaZ [class*="code-wrapper--"]::part(pre){white-space:pre-wrap;background:#fef5f3!important}.progress-container--tFUAQo73,
.stream-message--G0tAm9aa{border-radius:9px;border:1px solid #ccd1de;background:#fff}.progress-container--tFUAQo73{padding:6px 2px}.progress-fallback--Xto82BYu{background:#fef5f3}.stream-message--G0tAm9aa{padding:1em;margin:0.5em 0}.markdown-block--C3siNgW9{border:1px solid #ccd1de;border-radius:9px;padding:1em;background:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detail": `detail--JiiWugxP`,
	"code-block": `code-block--wccWPbbW`,
	"code-fallback": `code-fallback--a8nCduaZ`,
	"progress-container": `progress-container--tFUAQo73`,
	"stream-message": `stream-message--G0tAm9aa`,
	"progress-fallback": `progress-fallback--Xto82BYu`,
	"markdown-block": `markdown-block--C3siNgW9`
};
export default ___CSS_LOADER_EXPORT___;
